import * as Yup from 'yup';

export const deactivateRiderValidationSchema = Yup.object().shape({
  reasonKey: Yup.string().required('Please select a deactivation reason'),
});
